import {
  $Departments,
  setDepartments,
  fetchDepartments,
} from "@store/company/departments-store";
import { ImportEmployeesInvalidDataItem } from "@interfaces/company/employees";
import {
  addImportedPositions,
  addImportedDepartments,
} from "@store/company/import-employees-store";

import departmentService from "@services/department-service";
import { openFile } from "@utils/openFile";
import { useNavigate } from "react-router-dom";
import { useModal } from "@modals/index";
import { useUnit } from "effector-react";
import { useSelectedCompanyQuery } from "../company";

export const useImportDepartments = () => {
  const modal = useModal();
  const history = useNavigate();

  const { company } = useSelectedCompanyQuery();

  const departments = useUnit($Departments);

  const handleInvalidData = async (
    data: ImportEmployeesInvalidDataItem[]
  ): Promise<void> => {
    return new Promise((resolve) => {
      let text = "В следующих строках были обнаружены ошибки:<br>";
      data.forEach((item) => {
        const errors = Object.entries(item.errors).map(
          ([field, error]) => `<b>[${field}]</b> ${error}`
        );
        text += `<details><summary><b>Строка ${
          item.rowNumber
        }:</b></summary>${errors.join("<br>")}</details>`;
      });

      modal.open("NotificationModal", {
        btnText: "Закрыть",
        modalData: {
          style: {
            width: "600px",
          },
          modalTitle: "Ошибка при загрузке сотрудников",
          titleStyle: {
            color: "#E57373",
          },
          removeIcon: true,
          text2: text,
          textStyle: {
            textAlign: "left",
          },
        },
        onConfirm: () => {
          resolve();
        },
      });
    });
  };

  return async () => {
    if (!company) return;

    const file = await openFile({
      accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    if (!file) return;

    const data = await departmentService.importFromFile(company.id, file);

    if (data.invalidData.length > 0) {
      await handleInvalidData(data.invalidData);
    }

    setDepartments([...departments, ...data.addedDepartments]);

    const missingDepartments = new Set<number>();
    const missingPositions = new Set<number>();
    for (const department of departments) {
      const departmentWasInFile = data.existingInFileDepartments.includes(
        department.id
      );
      if (!departmentWasInFile) {
        missingDepartments.add(department.id);
      }

      for (const position of department.positions) {
        const positionWasInFile = data.existingInFilePositions.includes(
          position.id
        );
        if (!positionWasInFile) {
          missingPositions.add(position.id);
        }
      }
    }

    addImportedDepartments([...missingDepartments]);
    addImportedPositions([...missingPositions]);

    fetchDepartments();

    modal.open("ConfirmActionModal", {
      btnText: "Выполнить",
      modalData: {
        removeIcon: true,
        text: 'Данные загружены. Укажите необходимые программы и сведения о проведённых обучениях и инструктажах в разделах "Подразделения" и "Сотрудники"',
        cancelBtnText: "Позже",
        onCancel: () => {
          modal.close();
        },
      },
      onConfirm: () => {
        modal.close();
        history("/company/departments");
      },
    });
  };
};
